import { Spinner } from "react-bootstrap";
import "./index.css";
export default function Loading() {
  return (
    <div className="Loading position-fixed d-flex justify-content-center align-items-center">
      <Spinner variant='primary' animation="border" />
    </div>
  );
}
